/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, type OnDestroy, type OnInit, type SimpleChanges, Directive, Input } from '@angular/core';
import { type Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DETAIL_LOADING_DELAY } from '../const';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class RefreshComponent implements OnInit, OnDestroy, OnChanges {
    @Input() item;
    $destroy = new Subject<void>();
    updateLoading = false;
    timer;
    propName = 'item';
    protected changeDetectorRef;

    ngOnInit(): void {
        this.requestInfo()
            .pipe(takeUntil(this.$destroy))
            .subscribe(this.handleRequest.bind(this));
    }

    ngOnDestroy(): void {
        this.clearTimer();
        this.$destroy.next();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { [this.propName]: { firstChange, previousValue, currentValue } } = changes;
        if (!firstChange && previousValue !== currentValue) {
            this.timer = setTimeout(() => {
                this.updateLoading = true;
                this.changeDetectorRef.detectChanges();
            }, DETAIL_LOADING_DELAY);
            this.ngOnInit();
        }
    }

    abstract requestInfo(): Observable<any>;

    abstract handleRequest(value: any): void;

    clearTimer(): void {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
}
